/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 1.8em;
  font-weight: 300;
  text-align: center;
`;
